import { Add as AddIcon } from '@mui/icons-material';

const Add = (): JSX.Element => <AddIcon fontSize="inherit" />;

export default Add;
